// extracted by mini-css-extract-plugin
export default {"nowrap":"util_nowrap__4DGGr","amount":"util_amount__NMY7y","scrollX":"util_scrollX__Kaw6I","scrollAuto":"util_scrollAuto__Dcewe"};